module.exports = __webpack_public_path__ + "img/BRDE-LABS-2022.6bdd316a.png";